<div class="vh-100 d-flex justify-content-center align-items-center">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="card">
          <div class="card-body p-5">
            <div>
              <img src="assets/images/logo.png" style="width: 5rem;">
              <h2 class="d-inline-block ms-2" style="position: relative; top: 0.5rem;" i18n>Nuuduu Media</h2>
            </div>
            <div class="input-group float-end" style="width: 10rem; position: relative; top: -1rem;">
              <span class="input-group-text"><fa-icon [icon]="fa.faGlobe"></fa-icon></span>
              <select [(ngModel)]="activeLocale" class="form-control"(change)="language()">
                <option *ngFor="let locale of environment.locales" [ngValue]="locale">{{ locale| i18nSelect: locales }}</option>
              </select>
            </div>
            <form class="mb-3 mt-md-4" [formGroup]="loginForm" (ngSubmit)="login()">
              <div class="mb-3">
                <label for="email" class="form-label" i18n>Email address</label>
                <input type="email" class="form-control" id="email" autocomplete="username" formControlName="email">
              </div>
              <div class="mb-3">
                <label for="password" class="form-label" i18n>Password</label>
                <input type="password" class="form-control" id="password" autocomplete="current-password" formControlName="password">
              </div>
              <div class="d-grid">
                <button [disabled]="!loginForm.valid" class="btn btn-primary" type="submit" i18n>Login</button>
              </div>

              <p class="text-center mt-3">
                <span i18n>Don't have an account yet?</span>&nbsp;<a routerLink="/signup" i18n>Sign up here.</a>&nbsp;<span i18n>It's free.</span>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>